import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const WorkFlowInput = () => {
  const { workflowId = '' } = useParams();
  const decodedId = workflowId ? atob(workflowId) : workflowId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'workflow';

  useEffect(() => {
    if (workflowId) {
      setIsEditing(true);
      fetchWorkflowDetails();
    }
  }, [workflowId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchWorkflowDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.workflow}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching workflow details:', error);
    }
  };

  const workflowFields = [
    { name: 'workflow_name', label: 'Workflow Name', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea' },
    {
      name: 'workflow_type', label: 'Workflow Type', type: 'select',
      options: [
        { value: 'automation', label: 'Automation' },
        { value: 'approval', label: 'Approval' },
        { value: 'notification', label: 'Notification' },
        { value: 'assignment', label: 'Assignment' },
        { value: 'escalation', label: 'Escalation' },
      ],
    },
    {
      name: 'trigger', label: 'Trigger Event', type: 'select',
      options: [
        { value: 'lead_created', label: 'Lead Created' },
        { value: 'lead_updated', label: 'Lead Updated' },
        { value: 'stage_changed', label: 'Stage Changed' },
        { value: 'deal_closed', label: 'Deal Closed' },
        { value: 'task_overdue', label: 'Task Overdue' },
        { value: 'scheduled', label: 'Scheduled' },
        { value: 'manual', label: 'Manual' },
      ],
    },
    {
      name: 'status', label: 'Status', type: 'select',
      options: [
        { value: 'draft', label: 'Draft' },
        { value: 'active', label: 'Active' },
        { value: 'paused', label: 'Paused' },
        { value: 'inactive', label: 'Inactive' },
      ],
    },
    {
      name: 'priority', label: 'Priority', type: 'select',
      options: [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
        { value: 'critical', label: 'Critical' },
      ],
    },
    { name: 'conditions', label: 'Conditions', type: 'textarea' },
    { name: 'actions', label: 'Actions', type: 'textarea' },
    { name: 'schedule', label: 'Schedule (cron / interval)', type: 'text' },
    {
      name: 'assigned_to', label: 'Assigned To', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    { name: 'is_active', label: 'Is Active', type: 'checkbox' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Workflow' : 'Create New Workflow'}</h1>
      <FormComponent fields={workflowFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default WorkFlowInput;
